<template>
  <div class="loading-container">
    <div v-if="variant === 'migration'" class="migration-container">
      <v-skeleton-loader type="button"></v-skeleton-loader>
      <div class="loading-table pt-8 px-5">
        <v-skeleton-loader class="mb-10" type="text"></v-skeleton-loader>
        <v-skeleton-loader class="mb-10" type="text"></v-skeleton-loader>
        <v-skeleton-loader class="mb-10" type="text"></v-skeleton-loader>
        <v-skeleton-loader class="mb-10" type="text"></v-skeleton-loader>
        <v-skeleton-loader class="mb-10" type="text"></v-skeleton-loader>
        <v-skeleton-loader type="text"></v-skeleton-loader>
      </div>
    </div>
    <div v-else-if="variant === 'indicators'" class="indicators-container">
      <v-skeleton-loader type="button"></v-skeleton-loader>
      <div class="loading-graph px-5">
        <div class="loading-dates py-8">
          <v-skeleton-loader type="actions"></v-skeleton-loader>
        </div>
        <v-skeleton-loader class="mb-10" type="text"></v-skeleton-loader>
        <v-skeleton-loader class="mb-10" type="text"></v-skeleton-loader>
        <v-skeleton-loader class="mb-10" type="text"></v-skeleton-loader>
        <v-skeleton-loader class="mb-10" type="text"></v-skeleton-loader>
        <v-skeleton-loader class="mb-10" type="text"></v-skeleton-loader>
        <v-skeleton-loader type="text"></v-skeleton-loader>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingState',
  props: {
    variant: {
      type: String,
      default: 'migration',
      validator: (value) => ['migration', 'indicators'].includes(value),
    },
  },
}
</script>

<style lang="scss" scoped>
.loading-container {
  .migration-container {
    ::v-deep .v-skeleton-loader {
      .v-skeleton-loader__button {
        background-color: $cinza-l80 !important;
        width: 181px !important;
        height: 28px !important;
      }
    }
    .loading-table {
      .v-skeleton-loader {
        margin: 0 auto;
        max-width: 75%;
      }
    }
    ::v-deep .v-skeleton-loader__actions {
      .v-skeleton-loader__button {
        background-color: $cinza-l80 !important;
        width: 265px;
        height: 44px;
        margin: 0px 16px;
      }
    }
    ::v-deep .v-skeleton-loader__text {
      height: 8px;
      background-color: $cinza-l80 !important;
    }

    ::v-deep .v-skeleton-loader__actions {
      padding: 0px;
      text-align: center;
    }
  }
  .indicators-container {
    ::v-deep .v-skeleton-loader {
      .v-skeleton-loader__button {
        background-color: $cinza-l80 !important;
        width: 181px !important;
        height: 28px !important;
      }
    }
    .loading-graph {
      .v-skeleton-loader {
        margin: 0 auto;
        max-width: 75%;
      }
    }
    ::v-deep .v-skeleton-loader__actions {
      .v-skeleton-loader__button {
        background-color: $cinza-l80 !important;
        width: 265px;
        height: 44px;
        margin: 0px 16px;
      }
    }
    ::v-deep .v-skeleton-loader__text {
      height: 8px;
      background-color: $cinza-l80 !important;
    }

    ::v-deep .v-skeleton-loader__actions {
      padding: 0px;
      text-align: center;
    }
  }
}
</style>
